<template>
  <el-dialog :title="title" :visible.sync="visible" append-to-body :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="文章" prop="content_id">
        <el-select v-model="formData.content_id" placeholder="请选择文章" filterable :filter-method="getContentList" clearable @clear="getContentList">
          <el-option label="选择文章" :value="0"></el-option>
          <el-option v-for="item in contentList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="音频" prop="audio_id">
        <el-select v-model="formData.audio_id" placeholder="请选择音频" filterable :filter-method="getAudioList" clearable @clear="getAudioList">
          <el-option label="选择音频" :value="0"></el-option>
          <el-option v-for="item in audioList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频" prop="video_id">
        <el-select v-model="formData.video_id" placeholder="请选择视频" filterable :filter-method="getVideoList" clearable @clear="getVideoList">
          <el-option label="选择视频" :value="0"></el-option>
          <el-option v-for="item in videoList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'special_content_add',
  props: [
    'visible', 'id', 'special_id'
  ],
  data () {
    return {
      title: '添加专题文章',
      contentList: [],
      audioList: [],
      videoList: [],
      formData: {
        special_id: 0,
        content_id: 0
        // audio_id: 0,
        // video_id: 0
      },
      addFormRules: {
        content_id: [
          { required: true, message: '文章不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.formData = {
        special_id: 0,
        content_id: 0,
        audio_id: 0,
        video_id: 0
      }
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      this.formData.special_id = this.special_id
      this.getContentList('')
      this.getAudioList('')
      this.getVideoList('')
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑专题文章'
        this.getInfo(this.id)
      } else {
        this.title = '添加专题文章'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/special_content/info/' + id)
      if (res.code === 0) {
        this.formData.content_id = res.data.content_id
        this.formData.audio_id = res.data.audio_id
        this.formData.video_id = res.data.video_id
        this.getContentList('')
      }
    },
    async getContentList (value) {
      const res = await this.$http.get('/admin/content/select_list', { keyword: value, id: this.formData.content_id })
      if (res.code === 0) {
        this.contentList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAudioList (value) {
      const res = await this.$http.get('/admin/media/select_list', { keyword: value, type: 1 })
      if (res.code === 0) {
        this.audioList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getVideoList (value) {
      const res = await this.$http.get('/admin/media/select_list', { keyword: value, type: 2 })
      if (res.code === 0) {
        this.videoList = res.data
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
